import { render, staticRenderFns } from "./ListUltimasMultasUser.vue?vue&type=template&id=dfbf57be"
import script from "./ListUltimasMultasUser.vue?vue&type=script&lang=js"
export * from "./ListUltimasMultasUser.vue?vue&type=script&lang=js"
import style0 from "./ListUltimasMultasUser.vue?vue&type=style&index=0&id=dfbf57be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports